var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToGmx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5773 11.239L22.4889 7.24525H20.5378L19.521 9.27025L18.4271 7.24525H16.2895L18.5437 11.2345L16.2895 15.7345H18.4271L19.6466 13.1762L21.0919 15.7345H23L20.5773 11.239ZM13.5082 7.24525L12.0574 11.788L10.6819 7.24525H8.94783L7.79654 15.7457H9.54858L10.1153 10.8475H10.1332L11.6862 15.7457H12.3873L14.0139 10.8475H14.0354L14.5285 15.7457H16.2895L15.2638 7.24525H13.5082ZM4.5776 11.005V12.733H6.01223C5.93691 13.7027 5.3523 14.2 4.59553 14.2C3.44425 14.2 2.82198 12.8702 2.82198 11.5563C2.82198 10.2422 3.41914 8.89 4.56863 8.89C5.27519 8.89 5.78089 9.4255 6.02299 10.2287L7.68357 9.35575C7.10434 7.78075 6.03195 7 4.64754 7C2.47946 7 1 8.8 1 11.5427C1 14.2 2.47049 16 4.58657 16C5.71096 16 6.70264 15.496 7.35898 14.344C7.94897 13.3 8.02967 12.238 8.0476 11.005H4.5776Z",
    fill: "#1C449B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToGmx);
export default __webpack_public_path__ + "static/media/toGMX.04b698eee13050052ba1c349aa766ac4.svg";
export { ForwardRef as ReactComponent };